import {
  DeviceActions,
  DeviceActionTypes,
} from './device.actions';
import {DeviceStateInterface} from './device.model';
import moment from 'moment';
import { mysqlTimestampFormat } from '../../shared/helper/date';
import { SelectElementOptions } from '../../layout/main/main.model';

export const DeviceInitialState: DeviceStateInterface = {
  page: 1,
  pageCount: 1,
  itemCount: 1,
  itemTotal: 1,
  errors: [],
  filters: null,
  getDeviceLoading: false,
  getDeviceLoaded: false,
  getDeviceTypesLoading: false,
  getDeviceTypesLoaded: false,

  getClientsLoading: false,
  getClientsLoaded: false,
  getSitesLoading: false,
  getSitesLoaded: false,
  getLinesLoading: false,
  getLinesLoaded: false,
  getConnectionProfilesLoading: false,
  getConnectionProfilesLoaded: false,

  createDeviceLoading: false,
  createDeviceCompleted: false,
  updateDeviceLoading: false,
  updateDeviceCompleted: false,
  registerDevicesLoading: false,
  registerDevicesLoaded: false,
  sendMessageToDeviceLoading: false,
  sendMessageToDeviceLoaded: false,
  getFirmwaresLoading: false,
  getFirmwaresLoaded: false,
  uploadFirmwareLoading: false,
  uploadFirmwareLoaded: false,
  abortUploadFirmwareLoading: false,
  abortUploadFirmwareLoaded: false,
  firmwares: [],
  tableSettings: [],
  deviceData: [],
  deviceTypes: [],
  clients: [],
  sites: [],
  lines: [],
  connectionProfiles: [],
  getConnectionStatusesLoading: false,
  getConnectionStatusesLoaded: false,
  connectionStatuses: [],
};

export function deviceReducer(state = DeviceInitialState, action: DeviceActions): DeviceStateInterface {
  switch (action.type) {
    case DeviceActionTypes.GetDevices:
      return {
        ...state,
        getDeviceLoading: true,
        getDeviceLoaded: false,
      };
    case DeviceActionTypes.GetDevicesCompleted:
      return {
        ...state,
        getDeviceLoading: false,
        getDeviceLoaded: true,
        deviceData: action.deviceList,
        itemTotal: action.itemTotal,
      };
    case DeviceActionTypes.CreateDevice:
      return {
        ...state,
        createDeviceLoading: true,
        createDeviceCompleted: false,
      };
    case DeviceActionTypes.CreateDeviceCompleted:
      return {
        ...state,
        createDeviceLoading: false,
        createDeviceCompleted: true,
      };
    case DeviceActionTypes.UpdateDevice:
      return {
        ...state,
        updateDeviceLoading: true,
        updateDeviceCompleted: false,
      };
    case DeviceActionTypes.UpdateDeviceCompleted:
      return {
        ...state,
        updateDeviceLoading: false,
        updateDeviceCompleted: true,
      };

    case DeviceActionTypes.SetTableSettings:
      return {
        ...state,
        tableSettings: action.payload,
      };

    case DeviceActionTypes.GetDeviceTypes:
      return {
        ...state,
        getDeviceTypesLoading: true,
        getDeviceTypesLoaded: false,
      };

    case DeviceActionTypes.GetDeviceStatusesForGrid:
      return {
        ...state,
        getConnectionStatusesLoading: true,
        getConnectionStatusesLoaded: false,
      };

    case DeviceActionTypes.GetDeviceStatusesForGridCompleted:
      return {
        ...state,
        getConnectionStatusesLoading: false,
        getConnectionStatusesLoaded: true,
        connectionStatuses: action.deviceStatuses.data,
      };

    case DeviceActionTypes.GetDeviceTypesCompleted:
      const deviceTypeDropdownResource: SelectElementOptions[] = [];

      for (const item of action.data) {
        deviceTypeDropdownResource.push({
          label: item.name,
          value: String(item.id),
        });
      }

      return {
        ...state,
        deviceTypes: deviceTypeDropdownResource,
        getDeviceTypesLoading: false,
        getDeviceTypesLoaded: true,
      };

    case DeviceActionTypes.GetClients:
      return {
        ...state,
        getClientsLoading: true,
        getClientsLoaded: false,
      };

    case DeviceActionTypes.GetClientsCompleted:
      return {
        ...state,
        clients: action.data,
        getClientsLoading: false,
        getClientsLoaded: true,
      };

    case DeviceActionTypes.GetSites:
      return {
        ...state,
        getSitesLoading: true,
        getSitesLoaded: false,
      };

    case DeviceActionTypes.GetSitesCompleted:
      const siteDropdownResource: SelectElementOptions[] = [];

      for (const item of action.data) {
        siteDropdownResource.push({
          label: item.name,
          value: String(item.id),
        });
      }

      return {
        ...state,
        sites: siteDropdownResource,
        getSitesLoading: false,
        getSitesLoaded: true,
      };

    case DeviceActionTypes.GetLines:
      return {
        ...state,
        getLinesLoading: true,
        getLinesLoaded: false,
      };

    case DeviceActionTypes.GetLinesCompleted:
      const lineDropdownResource: SelectElementOptions[] = [];

      for (const item of action.data) {
        lineDropdownResource.push({
          label: item.name,
          value: String(item.id),
        });
      }

      return {
        ...state,
        lines: lineDropdownResource,
        getLinesLoading: false,
        getLinesLoaded: true,
      };

    case DeviceActionTypes.GetConnectionProfiles:
      return {
        ...state,
        getConnectionProfilesLoading: true,
        getConnectionProfilesLoaded: false,
      };

    case DeviceActionTypes.GetConnectionProfilesCompleted:
      const connectionProfilesDropdownResource: SelectElementOptions[] = [];

      for (const item of action.data) {
        connectionProfilesDropdownResource.push({
          label: item.name,
          value: String(item.id),
        });
      }

      return {
        ...state,
        connectionProfiles: connectionProfilesDropdownResource,
        getConnectionProfilesLoading: false,
        getConnectionProfilesLoaded: true,
      };

    case DeviceActionTypes.ClearState:
      return { ...DeviceInitialState };

    case DeviceActionTypes.FetchError:
      return {
        ...state,
        errors: action.payload,
      };

    case DeviceActionTypes.SetSelectedFilters:
      if (action.filters.filterStartDate) {
        action.filters.filterStartDate = moment(action.filters.filterStartDate).format(mysqlTimestampFormat);
      }

      if (action.filters.filterEndDate) {
        action.filters.filterEndDate = moment(action.filters.filterEndDate).format(mysqlTimestampFormat);
      }

      return {
        ...state,
        filters: action.filters,
      };

    case DeviceActionTypes.RegisterDevices:
      return {
        ...state,
        registerDevicesLoading: true,
        registerDevicesLoaded: false,
      };
    case DeviceActionTypes.RegisterDevicesCompleted:
      return {
        ...state,
        registerDevicesLoading: false,
        registerDevicesLoaded: true,
      };

    case DeviceActionTypes.SendMessageToDevice:
      return {
        ...state,
        sendMessageToDeviceLoading: true,
        sendMessageToDeviceLoaded: false,
      };
    case DeviceActionTypes.SendMessageToDeviceCompleted:
      return {
        ...state,
        sendMessageToDeviceLoading: false,
        sendMessageToDeviceLoaded: true,
      };

    case DeviceActionTypes.GetFirmwares:
      return {
        ...state,
        getFirmwaresLoading: true,
        getFirmwaresLoaded: false,
      };
    case DeviceActionTypes.GetFirmwaresCompleted:
      return {
        ...state,
        firmwares: action.firmwares,
        getFirmwaresLoading: false,
        getFirmwaresLoaded: true,
      };

    case DeviceActionTypes.UploadFirmware:
      return {
        ...state,
        uploadFirmwareLoading: true,
        uploadFirmwareLoaded: false,
      };
    case DeviceActionTypes.UploadFirmwareCompleted:
      return {
        ...state,
        uploadFirmwareLoading: false,
        uploadFirmwareLoaded: true,
      };
    case DeviceActionTypes.AbortUploadFirmware:
      return {
        ...state,
        abortUploadFirmwareLoading: true,
        abortUploadFirmwareLoaded: false,
      };
    case DeviceActionTypes.AbortUploadFirmwareCompleted:
      return {
        ...state,
        abortUploadFirmwareLoading: false,
        abortUploadFirmwareLoaded: true,
      };

    default:
      return state;
  }
}
